import { FC } from "react";
import cls from "classnames";
import { SquarePen } from "lucide-react";
import useWork from "@/hooks/useWork";
import styles from "./index.module.scss";

const BtnAdd: FC<{ isLeftPanel: boolean }> = ({ isLeftPanel }) => {
  const { addGenerateTask } = useWork();

  const handleAdd = () => {
    addGenerateTask();
  };

  return (
    <button
      onClick={handleAdd}
      className={cls({ [styles.button]: true, [styles.large]: isLeftPanel })}
    >
      <SquarePen className={styles.add} />
      {isLeftPanel && "创作课程"}
    </button>
  );
};

export default BtnAdd;
